import Image from "../../../../shared/components/Image";
import React from "react";
import { useTranslation } from "react-i18next";
import "./styles.scss";
import { Trikot } from "../../../assets/svg/Trikot";
import { getPlayerShorLastName, getShortPlayerName } from "../../../../shared/feeds/worldcup/playerHelper";
import { getPlayerPosition } from "../../../../shared/utils/players";
import { getDynamicLogoPath } from "../../../../shared/utils/functions";
import PlayerImage from "../../../../shared/components/Image/PlayerImage";
import BildPlayerImage from "../../../../shared/components/Image/BildPlayerImage";
import BildTeamLogo from "../../../../shared/components/Image/BildTeamLogo";

export const BildPlayerTriko = ({
  player,
  teamId,
  className = "",
  side = "home",
  bgColor,
  team,
  position
}) => {
  const { t } = useTranslation();
  // const fallbackBg = side ==='home' ? '#007df8' : '#f52724'
  const fallbackBg =
    side === "home" ? "rgba(255,255,255,0.4)" : "rgba(255,255,255,0.4)";
  const playerStyle = {
    "--triko-svg-color": bgColor ? bgColor : fallbackBg,
  };
  return (
    <div style={playerStyle} className={`bild-comp-player-triko ${className}`}>
      <div className={`player player-${side}`}>
        <div className={"player-info"}>
          <div className="player-image-wrapper">
            <BildPlayerImage
              className="player-avatar" id={player?.person?.id} />
          </div>
          <div className={`player-name ${side}`}>
            <div className={"player-lastname"}>
              {player?.person?.surname}
            </div>
          </div>
          <div className={`player-position ${side}`}>
            {position}
            {/* {t(position, {keyPrefix: "templates"})} */}
            {/* {t(getPlayerPosition(player), { keyPrefix: "templates", defaultValue: '-' })} */}
          </div>
        </div>

        <div className={`team-logo-wrapper ${side}`}>
          <div className={`team-logo-container ${side}`}>
            <BildTeamLogo
              className="team-logo"
              id={team?.id}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
